import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { MyIcon } from "../../common/baseConfig";
import { connect } from 'react-redux';
import { Button } from "antd";
import * as actions from './redux/actions';
import NoneData from "../common/NoneData";
export class CourseDownload extends Component {
  static propTypes = {
    course: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    const { CourseID } = this.props;
    this.props.actions.fetchGetCourseDoc({
      Course_ID: CourseID,
    })
  }
  getExt(path) {
    path = path.substring(path.lastIndexOf(".") + 1, path.length);
    return path;
  }
  getDocumentIcon(path) {
    let ext = this.getExt(path);
    switch (ext) {
      case "jpg":
        return 'iconjpg'
      case "png":
        return 'iconpng'
      case "excel":
        return 'iconexcel'
      case "pdf":
        return 'iconpdf'
      case "doc":
        return "iconword"
      case "docx":
        return "iconword"
      case "ppt":
        return "iconppt"
      case "zip":
        return "iconzip"
      case "rar":
        return "iconzip"
      default:
        return "iconwenjian"
    }
  }
  getSize(size) {
    if (size > 1024) {
      size = (size / 1024).toFixed(1);
      if (size > 1024) {
        return (size / 1024).toFixed(1) + "M"
      } else {
        return size + "KB";
      }
    } else {
      return size + "B";
    }
  }
  render() {
    const { CourseName } = this.props;
    const { fetchGetCourseDocSuccess } = this.props.course;
    if (!fetchGetCourseDocSuccess) return null;
    return (
      <div className="course-course-download">
        <h1>{CourseName}</h1>
        {
          fetchGetCourseDocSuccess.length > 0 ? <div className="docments">
            {
              fetchGetCourseDocSuccess.map(item => (
                <div className="document" key={item.ID}>
                  <p>
                    <span><MyIcon type={this.getDocumentIcon(item.Path)} style={{ fontSize: 24 }} /></span><span>{item.Title}.{this.getExt(item.Path)}</span>
                  </p>
                  <p>
                    <span className="size">{this.getSize(item.DataSize)}</span>
                    <a href={item.Path} target="_blank" download={item.Title + "." + this.getExt(item.Path)}><Button type="theme" className="download">下载</Button></a>
                  </p>
                </div>
              ))
            }
          </div> : <div className="noneData">
              <NoneData type={1} />
            </div>
        }
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    course: state.course,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CourseDownload);



// WEBPACK FOOTER //
// ./src/features/course/CourseDownload.js